export const isPwa = () => {
  return ["fullscreen", "standalone", "minimal-ui"].some(
      (displayMode) =>
          window.matchMedia("(display-mode: " + displayMode + ")").matches
  );
};

export const isIos = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
  );
};

export const isNotifySupported = () => {
  return typeof window !== 'undefined' && "serviceWorker" in navigator && "Notification" in window && "PushManager" in window;
}

export const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}

export const getNotificationPermission = async () => {
  const registration = await navigator.serviceWorker.ready;

  if (!registration) {
    return false;
  }

  // we only care to adjust permission when it's default and only on iOS
  if (window.Notification.permission !== 'default' || !isIos()) {
    return window.Notification.permission;
  }

  // there's a possibility on iOS that user granted permission, but quit the app and permission got reset to "default"
  // it's a false "default" and will be reset to granted later
  const subscription = await registration.pushManager.getSubscription();

  if (subscription) {
    return 'granted';
  }

  return 'default';
}
